import React from 'react';

import styles from './CheckoutLayout.module.css';
import { useGetBuyerSpendingLimitRequest } from '../../../../api/lending/lapiHooks';
import { useSellerWhitelabelling } from '../../../../hooks/useSellerWhiteLabelling.hook';
import { CancelButton } from '../../../components/CancelButton/CancelButton';
import { HelpBox } from '../../../components/HelpBox/HelpBox';
import { WhiteLabelHeaderLogo } from '../../../components/WhiteLabelLogo/WhiteLabelLogo';
import { WhiteLabelOverride } from '../../../components/WhiteLabelOverride/WhiteLabelOverride';
import { useCurrentPayLink } from '../../hooks/useCurrentPayLink';
import { RequirementsRouteConfig } from '../../routes';
import { CheckoutProgressIndicator } from '../CheckoutProgressIndicator';

export const CheckoutLayout = ({
  children,
  routes,
}: {
  children: React.ReactNode;
  routes: RequirementsRouteConfig[];
}) => {
  const { spendingLimitRequest } = useGetBuyerSpendingLimitRequest();
  const { payLink } = useCurrentPayLink();
  const cancelUrl = payLink?.cancel_url;
  // don't show cancel button on the captured payout complete page
  const shouldShowCancelButton =
    !window.location.pathname.includes('offer/complete');

  // White-label theme.
  const { theme, showSellerLogo } = useSellerWhitelabelling(
    payLink?.seller_handle || spendingLimitRequest?.data?.seller_handle,
  );

  return (
    <>
      <div className={styles.Checkout}>
        {theme && showSellerLogo && (
          <div className="mx-auto max-w-[600px]">
            <WhiteLabelHeaderLogo
              // showSellerLogo = true --> logo_uri & preferred_logo_type present.
              url={theme.logo_uri!}
              ratio={theme.preferred_logo_type!}
            />
          </div>
        )}
        <WhiteLabelOverride componentType="progress">
          <CheckoutProgressIndicator routes={routes} />
        </WhiteLabelOverride>
        <div className={styles.requirement}>
          {shouldShowCancelButton && (
            <CancelButton
              className={styles.cancelButton}
              href={cancelUrl ?? undefined}
            />
          )}
          {children}
          <HelpBox />
        </div>
      </div>
    </>
  );
};
